import { ListItemIcon, styled } from '@mui/material'

export default styled(ListItemIcon)(({ theme }) => ({
  minWidth: 36,
  color: '#000',
}))
